var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.75 5.25H3.45C3.02996 5.25 2.81994 5.25 2.65951 5.33175C2.51839 5.40365 2.40365 5.51839 2.33175 5.65951C2.25 5.81994 2.25 6.02996 2.25 6.45V14.55C2.25 14.97 2.25 15.1801 2.33175 15.3405C2.40365 15.4816 2.51839 15.5964 2.65951 15.6683C2.81994 15.75 3.02996 15.75 3.45 15.75H6.75M6.75 15.75H11.25M6.75 15.75L6.75 3.45C6.75 3.02996 6.75 2.81994 6.83175 2.65951C6.90365 2.51839 7.01839 2.40365 7.15951 2.33175C7.31994 2.25 7.52996 2.25 7.95 2.25L10.05 2.25C10.47 2.25 10.6801 2.25 10.8405 2.33175C10.9816 2.40365 11.0964 2.51839 11.1683 2.65951C11.25 2.81994 11.25 3.02996 11.25 3.45V15.75M11.25 8.25H14.55C14.97 8.25 15.1801 8.25 15.3405 8.33175C15.4816 8.40365 15.5964 8.51839 15.6683 8.65951C15.75 8.81994 15.75 9.02996 15.75 9.45V14.55C15.75 14.97 15.75 15.1801 15.6683 15.3405C15.5964 15.4816 15.4816 15.5964 15.3405 15.6683C15.1801 15.75 14.97 15.75 14.55 15.75H11.25",
    stroke: "#5926F0",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsA);
export default __webpack_public_path__ + "static/media/analytics_a.3fb18c48aeb78c352aae7c88b173a3a8.svg";
export { ForwardRef as ReactComponent };